import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import {baseUrl} from '../../config';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";
import axiosIntance,{fetchInstance} from '../../helper/axios';
function Shipstation() {

  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader,setLoader]=useState(false)
  const [resultCount,setResultCount]=useState(0);
  const [resultCountCounter,setResultCountCounter]=useState(0);
  checkUserTypeFn(history);

function checkUserTypeFn(history){
  const userdata=JSON.parse(localStorage.getItem('userdata'));
  const usertype=userdata.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
    history.push('/');
 }

}
  const handleSignOut = () => {
    window.localStorage.setItem('isLogin',false);
    history.push('/');
  }

  const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
      
  if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
    history.push('/');
  }

  const [shippingData,setShippingData]=useState([])
  
  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg,setSuccessMsg]=useState('')
  useEffect(() => {
    setLoader(true)
    
    axiosIntance.get(baseUrl+'/count/shipstation', {}).then(response => {
      console.log('resultCount='+response.data.result);
      setResultCount(response.data.result);
      setResultCountCounter(1);
      setLoader(false)
    }).catch(error => {
      console.log(error)
      setMessage('Something went wrong');
    });


    return () => {
      console.log('un subscribe')
    }



  }, [])
 

  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () => 
          axiosIntance.delete(baseUrl+'/shipstation', {}).then(response => {
            setSuccessMsg('Deleted!')
           // setTimeout(()=>window.location.href = '/viewShippingRates',2000)
          }).catch(error => {
            setMessage('Something went wrong');
          })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }
 
  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

    <div className='delete-div'>
      {
        resultCount.length>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>




  


      <section id="content-wrapper">

      {loader &&
    <div className='loaderDiv'>  
        <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
              //timeout={1000} //3 secs
          />
    </div> 
    }
    {resultCountCounter>0 && 
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}																									

          columns={[
             { title: "Carrier - Name", field: "carrier_name" },
            { title: "Carrier - Service Selected", field: "carrier_service_selected" },
            { title: "Count - Number of Line Items", field: "count_number_of_line_items" },
            { title: "Custom - Field 1", field: "custom_field_1" },
            { title: "Custom - Field 2", field: "custom_field_2" },
            { title: "Custom - Field 3", field: "custom_field_3" },
            { title: "Customer - Email", field: "customer_email" },
            { title: "Date - Label Create Date", field: "date_label_create_date" },
            { title: "Date - Order Date", field: "date_order_date" },
            { title: "Date - Shipped Date", field: "date_shipped_date" },
            { title: "Delivery - Date", field: "delivery_date" },

            { title: "Delivery - Message", field: "delivery_message" },
            { title: "Order - Number", field: "order_number" },
            { title: "Order - Source", field: "order_source" },
            { title: "Order - Status", field: "order_status" },
            { title: "Ship To - Address 1", field: "ship_to_address_1" },
            { title: "Ship To - Address 2", field: "ship_to_address_2" },
            { title: "Ship To - Address 3", field: "ship_to_address_3" },
            { title: "Ship To - City", field: "ship_to_city" },
            { title: "Ship To - Company", field: "ship_to_company" },
            { title: "Ship To - Country", field: "ship_to_country" },

            { title: "Ship To - Name", field: "ship_to_name" },
            { title: "Ship To - Phone", field: "ship_to_phone" },
            { title: "Ship To - Postal Code", field: "ship_to_postal_code" },
            { title: "Ship To - Residential Flag", field: "ship_to_residential_flag" },
            { title: "Ship To - State", field: "ship_to_state" },
            { title: "Ship To - Verified Flag", field: "ship_to_verified_flag" },

            
          ]}
          data={query =>
            new Promise((resolve, reject) => {
              // console.log(query)
           
              let url = baseUrl+'/shipstation?'
              url += `&_page=${query.page + 1}`
              url += `&_limit=${query.pageSize}`
              fetchInstance(url)
                .then(response => response.json())
                .then(result => {
                  resolve({
                    data: result.result,
                    page: query.page,
                    totalCount: resultCount,
                  })
                })
            })
          }
          options={{
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
            // headerStyle: { fontSize:'15px',fontWeight:'bold' },
            
          }}
          title="Shipstation Data"
        />
}
      </section>
    </div>
    // <section className="bg-back">

    // </section>
  )
}

export default Shipstation